import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveExercise } from '../../../api/diary-service';
import { useState } from 'react';

const useSaveExercise = (currentDay) => {
    const [isSavingAndSyncing, setIsSavingAndSyncing] = useState(false);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: saveExercise,
        onError: (error) => {
            console.error('Failed to save exercise:', error);
        }
    });

    const saveExerciseAndSync = async (payload) => {
        setIsSavingAndSyncing(true);

        try {
            const payloadWithDate = { ...payload, date: currentDay };

            await mutation.mutateAsync(payloadWithDate);
            await queryClient.refetchQueries({ queryKey: ['diary', currentDay] });
        } catch (err) {
            console.error('Save and sync failed:', err);
        } finally {
            setIsSavingAndSyncing(false);
        }
    };

    return {
        saveExercise: saveExerciseAndSync,
        isSaving: isSavingAndSyncing,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error,
        reset: mutation.reset
    };
};

export default useSaveExercise;
